import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { getDateAsObject } from "../../core/et3-date";
import { TSupervisedAuditEvent } from "../../Types";
import { post } from "../axios-post";

export const apiCallGetSupervisedAuditEvents = async ({
  adminId,
  dateMin,
  dateMax,
  limit,
  eventType,
  issueType
}: {
  adminId: number;
  dateMin: Date;
  dateMax: Date;
  limit: number;
  eventType: string;
  issueType: string;
}): Promise<{
  data: TSupervisedAuditEvent[];
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<TSupervisedAuditEvent[]>(
    `supervisor/getSupervisedAuditEvents`,
    {
      adminId,
      startDateObject: getDateAsObject(dateMin),
      endDateObject: getDateAsObject(dateMax),
      limit,
      issueType,
      eventType
    }
  );

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: [],
      status: "ERROR",
      code: "ERROR"
    };
  }
};
